import { render, staticRenderFns } from "./EditTagsModalV2.vue?vue&type=template&id=78ca29e3&scoped=true"
import script from "./EditTagsModalV2.vue?vue&type=script&lang=js"
export * from "./EditTagsModalV2.vue?vue&type=script&lang=js"
import style0 from "./EditTagsModalV2.vue?vue&type=style&index=0&id=78ca29e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ca29e3",
  null
  
)

export default component.exports